export default {"src":"/_next/static/media/play-button.84ecb041.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};